// //new style
// import { useEffect, useState } from "react";
// import axios from "axios";
// import API from "../api";



// export default function Records() {

//   const [data, setData] = useState([]);
//   const [selectedRow, setSelectedRow] = useState(null);

//   const user = JSON.parse(localStorage.getItem("user"));

//   const isAdmin = user?.role === "admin";

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = () => {

//     axios
//       .get(`${API}/api/transactions`, {
//         params: {
//           personId: user?.personId,
//           role: user?.role,
//         },
//       })
//       .then((res) => setData(res.data))
//       .catch((err) => console.log(err));
//   };

//   const handleWeekChange = (id, week, value) => {

//     if (!isAdmin) return;

//     const updatedWeeklyPayments = {
//       ...selectedRow.weeklyPayments,
//       [week]: Number(value)
//     };

//     const totalPaid = Object.values(updatedWeeklyPayments)
//       .reduce((sum, amt) => sum + Number(amt || 0), 0);

//     const updatedRow = {
//       ...selectedRow,
//       weeklyPayments: updatedWeeklyPayments,
//       paid: totalPaid
//     };

//     setSelectedRow(updatedRow);

//     setData(prev =>
//       prev.map(row =>
//         row._id === id ? updatedRow : row
//       )
//     );
//   };

//   const handleModalSave = async () => {

//     if (!isAdmin) return;

//     try {

//       await axios.put(
//         `${API}/api/transactions/${selectedRow._id}`,
//         selectedRow
//       );

//       alert("Saved Successfully");

//       setSelectedRow(null);

//       fetchData();

//     } catch (err) {

//       console.log(err);

//     }
//   };

//   const handleDelete = async (id) => {

//     if (!isAdmin) return;

//     if (!window.confirm("Delete this record?")) return;

//     await axios.delete(`${API}/api/transactions/${id}`);

//     setData((prev) =>
//       prev.filter((row) => row._id !== id)
//     );
//   };

//   return (
//     <div className="min-h-screen bg-[#f4f7fb] pb-24">

//       {/* HEADER */}
//       <div className="bg-white px-5 pt-6 pb-4 shadow-sm rounded-b-3xl">

//         <div className="flex items-center justify-between">

//           <div>
//             <h1 className="text-2xl font-bold text-slate-800">
//               Transactions Ledger
//             </h1>

//             <p className="text-sm text-slate-500 mt-1">
//               {isAdmin
//                 ? "Manage all loan records"
//                 : "View loan records"}
//             </p>
//           </div>

//           <button
//             onClick={() => {
//               localStorage.clear();
//               window.location.href = "/";
//             }}
//             className="bg-red-500 text-white px-4 py-2 rounded-2xl text-sm"
//           >
//             Logout
//           </button>

//         </div>

//       </div>

//       <div className="p-4">

//         <div className="space-y-4">

//           {data.map((row) => {

//             const paid = row.paid || 0;

//             const balance =
//               (row.amount * 1.75 || 0) - paid;

//             return (

//               <div
//                 key={row._id}
//                 className="bg-white rounded-3xl p-5 shadow-sm"
//               >

//                 <div className="flex justify-between items-start">

//                   <div>

//                     <button
//                       onClick={() => {
//                         setSelectedRow({
//                           ...row,
//                           weeklyPayments: {
//                             week1: 0,
//                             week2: 0,
//                             week3: 0,
//                             week4: 0,
//                             week5: 0,
//                             week6: 0,
//                             week7: 0,
//                             week8: 0,
//                             week9: 0,
//                             week10: 0,
//                             ...row.weeklyPayments
//                           }
//                         });
//                       }}
//                       className="text-xl font-bold text-slate-800"
//                     >
//                       {row.name}
//                     </button>

//                     <p className="text-sm text-slate-500 mt-1">
//                       {row.mobile}
//                     </p>

//                   </div>

//                   <div className="text-right">

//                     <p className="text-sm text-slate-500">
//                       Balance
//                     </p>

//                     <h2 className="text-xl font-bold text-red-500">
//                       ₹{balance}
//                     </h2>

//                   </div>

//                 </div>

//                 <div className="grid grid-cols-3 gap-3 mt-5">

//                   <div className="bg-slate-50 rounded-2xl p-3">
//                     <p className="text-xs text-slate-500">
//                       Loan
//                     </p>

//                     <h3 className="font-bold text-slate-800 mt-1">
//                       ₹{row.amount}
//                     </h3>
//                   </div>

//                   <div className="bg-slate-50 rounded-2xl p-3">
//                     <p className="text-xs text-slate-500">
//                       Paid
//                     </p>

//                     <h3 className="font-bold text-green-600 mt-1">
//                       ₹{paid}
//                     </h3>
//                   </div>

//                   <div className="bg-slate-50 rounded-2xl p-3">
//                     <p className="text-xs text-slate-500">
//                       Date
//                     </p>

//                     <h3 className="font-bold text-slate-800 mt-1">
//                       {row.date}
//                     </h3>
//                   </div>

//                 </div>

//                 {/* ADMIN BUTTONS */}
//                 {isAdmin && (
//                   <div className="flex gap-3 mt-5">

//                     <button
//                       onClick={() => handleDelete(row._id)}
//                       className="flex-1 bg-red-500 text-white py-3 rounded-2xl"
//                     >
//                       Delete
//                     </button>

//                     <button
//                       onClick={() => {
//                         setSelectedRow({
//                           ...row,
//                           weeklyPayments: {
//                             week1: 0,
//                             week2: 0,
//                             week3: 0,
//                             week4: 0,
//                             week5: 0,
//                             week6: 0,
//                             week7: 0,
//                             week8: 0,
//                             week9: 0,
//                             week10: 0,
//                             ...row.weeklyPayments
//                           }
//                         });
//                       }}
//                       className="flex-1 bg-blue-700 text-white py-3 rounded-2xl"
//                     >
//                       Edit Record
//                     </button>

//                   </div>
//                 )}

//                 {/* VIEW BUTTON FOR NON-ADMIN */}
//                 {!isAdmin && (
//                   <button
//                     onClick={() => {
//                       setSelectedRow({
//                         ...row,
//                         weeklyPayments: {
//                           week1: 0,
//                           week2: 0,
//                           week3: 0,
//                           week4: 0,
//                           week5: 0,
//                           week6: 0,
//                           week7: 0,
//                           week8: 0,
//                           week9: 0,
//                           week10: 0,
//                           ...row.weeklyPayments
//                         }
//                       });
//                     }}
//                     className="w-full mt-5 bg-slate-800 text-white py-3 rounded-2xl"
//                   >
//                     View Details
//                   </button>
//                 )}

//               </div>
//             );
//           })}

//         </div>

//       </div>

//       {/* MODAL */}
//       {selectedRow && (

//         <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">

//           <div className="bg-white w-full max-w-4xl rounded-3xl p-5 max-h-[95vh] overflow-auto">

//             <div className="flex justify-between items-center mb-5">

//               <h2 className="text-2xl font-bold">
//                 {selectedRow.name}
//               </h2>

//               <button
//                 onClick={() => setSelectedRow(null)}
//                 className="bg-red-500 text-white px-4 py-2 rounded-2xl"
//               >
//                 Close
//               </button>

//             </div>

//             {/* IMAGES */}
//             <div className="grid md:grid-cols-2 gap-5 mb-6">

//               <div className="bg-slate-50 rounded-3xl p-4 text-center">

//                 <h3 className="font-bold mb-4">
//                   Profile Photo
//                 </h3>

//                 <img
//                   src={selectedRow.profilePhoto}
//                   alt=""
//                   className="w-52 h-52 object-cover rounded-3xl mx-auto"
//                 />

//               </div>

//               <div className="bg-slate-50 rounded-3xl p-4 text-center">

//                 <h3 className="font-bold mb-4">
//                   ID Card
//                 </h3>

//                 <img
//                   src={selectedRow.idPhoto}
//                   alt=""
//                   className="w-52 h-52 object-cover rounded-3xl mx-auto"
//                 />

//               </div>

//             </div>

//             {/* WEEKLY */}
//             <div className="grid grid-cols-2 md:grid-cols-5 gap-3">

//               {Array.from({ length: 10 }, (_, i) => {

//                 const weekKey = `week${i + 1}`;

//                 return (
//                   <div
//                     key={i}
//                     className="bg-slate-50 rounded-2xl p-3"
//                   >

//                     <p className="text-sm font-semibold mb-2">
//                       Week {i + 1}
//                     </p>

//                     <input
//                       type="number"
//                       disabled={!isAdmin}
//                       value={
//                         selectedRow?.weeklyPayments?.[weekKey] || 0
//                       }
//                       onChange={(e) =>
//                         handleWeekChange(
//                           selectedRow._id,
//                           weekKey,
//                           e.target.value
//                         )
//                       }
//                       className={`w-full border rounded-xl px-3 py-2 outline-none ${
//                         isAdmin
//                           ? "bg-white border-slate-200"
//                           : "bg-slate-100 border-slate-100 cursor-not-allowed"
//                       }`}
//                     />

//                   </div>
//                 );
//               })}

//             </div>

//             {/* NOTES */}
//             <div className="mt-6">

//               <label className="font-bold block mb-2">
//                 Notes
//               </label>

//               <textarea
//                 disabled={!isAdmin}
//                 value={selectedRow.notes || ""}
//                 onChange={(e) =>
//                   setSelectedRow({
//                     ...selectedRow,
//                     notes: e.target.value,
//                   })
//                 }
//                 className={`w-full rounded-2xl p-4 ${
//                   isAdmin
//                     ? "bg-slate-50 border border-slate-200"
//                     : "bg-slate-100 border border-slate-100 cursor-not-allowed"
//                 }`}
//                 rows={4}
//               />

//             </div>

//             {/* SAVE ONLY FOR ADMIN */}
//             {isAdmin && (
//               <button
//                 onClick={handleModalSave}
//                 className="w-full bg-blue-700 hover:bg-blue-800 transition text-white py-4 rounded-2xl mt-6 font-semibold"
//               >
//                 Save Details
//               </button>
//             )}

//           </div>

//         </div>

//       )}

//     </div>
//   );
// }

// UPDATED records.js

import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import API from "../api";

export default function Records() {

  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  // NEW
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");

  const user = JSON.parse(localStorage.getItem("user"));

  const isAdmin = user?.role === "admin";

  useEffect(() => {

    if (!user) {
      window.location.href = "/login";
      return;
    }

    fetchData();

  }, []);

  const fetchData = async () => {

    try {

      const res = await axios.get(
        `${API}/api/transactions`,
        {
          params: {
            personId: user?.personId,
            role: user?.role,
          },
        }
      );

      setData(res.data);

    } catch (err) {

      console.log(err);

    }
  };

  // SEARCH + FILTER
  const filteredData = useMemo(() => {

    return data.filter((row) => {

      const searchMatch =
        row.name?.toLowerCase().includes(search.toLowerCase()) ||
        row.mobile?.includes(search);

      const total = Number(row.amount || 0) * 1.75;
      const paid = Number(row.paid || 0);
      const balance = total - paid;

      let filterMatch = true;

      if (filter === "pending") {
        filterMatch = balance > 0;
      }

      if (filter === "completed") {
        filterMatch = balance <= 0;
      }

      if (filter === "due") {

        if (!row.lastDate) return false;

        const today = new Date();
        const dueDate = new Date(row.lastDate);

        filterMatch = dueDate < today && balance > 0;
      }

      return searchMatch && filterMatch;

    });

  }, [data, search, filter]);

  // DASHBOARD STATS
  const stats = useMemo(() => {

    let totalLoan = 0;
    let totalPaid = 0;
    let totalProfit = 0;
    let dueCount = 0;

    data.forEach((row) => {

      const loan = Number(row.amount || 0);
      const paid = Number(row.paid || 0);

      const payable = loan * 1.75;

      totalLoan += loan;
      totalPaid += paid;
      totalProfit += payable - loan;

      const balance = payable - paid;

      if (row.lastDate) {

        const today = new Date();
        const dueDate = new Date(row.lastDate);

        if (dueDate < today && balance > 0) {
          dueCount++;
        }
      }
    });

    return {
      totalLoan,
      totalPaid,
      totalProfit,
      dueCount
    };

  }, [data]);

  const handleWeekChange = (id, week, value) => {

    if (!isAdmin) return;

    const updatedWeeklyPayments = {
      ...selectedRow.weeklyPayments,
      [week]: Number(value)
    };

    const totalPaid = Object.values(updatedWeeklyPayments)
      .reduce((sum, amt) => sum + Number(amt || 0), 0);

    const updatedRow = {
      ...selectedRow,
      weeklyPayments: updatedWeeklyPayments,
      paid: totalPaid
    };

    setSelectedRow(updatedRow);

    setData(prev =>
      prev.map(row =>
        row._id === id ? updatedRow : row
      )
    );
  };

  const handleModalSave = async () => {

    if (!isAdmin) return;

    try {

      await axios.put(
        `${API}/api/transactions/${selectedRow._id}`,
        selectedRow
      );

      alert("Saved Successfully");

      setSelectedRow(null);

      fetchData();

    } catch (err) {

      console.log(err);

    }
  };

  const handleDelete = async (id) => {

    if (!isAdmin) return;

    if (!window.confirm("Delete this record?")) return;

    await axios.delete(`${API}/api/transactions/${id}`);

    setData((prev) =>
      prev.filter((row) => row._id !== id)
    );
  };

  return (

    <div className="min-h-screen bg-[#f4f7fb] pb-24">

      {/* HEADER */}
      <div className="bg-white px-5 pt-6 pb-4 shadow-sm rounded-b-3xl">

        <div className="flex items-center justify-between">

          <div>

            <h1 className="text-2xl font-bold text-slate-800">
              Transactions Ledger
            </h1>

            <p className="text-sm text-slate-500 mt-1">
              {isAdmin
                ? "Manage all loan records"
                : "View loan records"}
            </p>

          </div>

          <button
            onClick={() => {

              localStorage.clear();

              window.location.href = "/login";

            }}
            className="bg-red-500 text-white px-4 py-2 rounded-2xl text-sm"
          >
            Logout
          </button>

        </div>

      </div>

      {/* STATS */}
      <div className="p-4">

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5">

          <div className="bg-white rounded-3xl p-4 shadow-sm">
            <p className="text-sm text-slate-500">
              Total Loan
            </p>

            <h2 className="text-2xl font-bold mt-2">
              ₹{stats.totalLoan}
            </h2>
          </div>

          <div className="bg-white rounded-3xl p-4 shadow-sm">
            <p className="text-sm text-slate-500">
              Total Paid
            </p>

            <h2 className="text-2xl font-bold text-green-600 mt-2">
              ₹{stats.totalPaid}
            </h2>
          </div>

          <div className="bg-white rounded-3xl p-4 shadow-sm">
            <p className="text-sm text-slate-500">
              Expected Profit
            </p>

            <h2 className="text-2xl font-bold text-blue-700 mt-2">
              ₹{stats.totalProfit}
            </h2>
          </div>

          <div className="bg-white rounded-3xl p-4 shadow-sm">
            <p className="text-sm text-slate-500">
              Due Alerts
            </p>

            <h2 className="text-2xl font-bold text-red-500 mt-2">
              {stats.dueCount}
            </h2>
          </div>

        </div>

        {/* SEARCH + FILTER */}
        <div className="bg-white rounded-3xl p-4 shadow-sm mb-5">

          <div className="grid md:grid-cols-2 gap-4">

            <input
              type="text"
              placeholder="Search by name or mobile"
              value={search}
              onChange={(e) =>
                setSearch(e.target.value)
              }
              className="w-full border border-slate-200 rounded-2xl px-4 py-3 outline-none"
            />

            <select
              value={filter}
              onChange={(e) =>
                setFilter(e.target.value)
              }
              className="w-full border border-slate-200 rounded-2xl px-4 py-3 outline-none"
            >
              <option value="all">
                All Records
              </option>

              <option value="pending">
                Pending Loans
              </option>

              <option value="completed">
                Completed Loans
              </option>

              <option value="due">
                Due Date Alerts
              </option>

            </select>

          </div>

        </div>

        {/* RECORDS */}
        <div className="space-y-4">

          {filteredData.map((row) => {

            const paid = row.paid || 0;

            const total = (row.amount * 1.75 || 0);

            const balance = total - paid;

            const completed = balance <= 0;

            const due =
              row.lastDate &&
              new Date(row.lastDate) < new Date() &&
              !completed;

            return (

              <div
                key={row._id}
                className="bg-white rounded-3xl p-5 shadow-sm"
              >

                <div className="flex justify-between items-start">

                  <div>

                    <button
                      onClick={() => {

                        setSelectedRow({
                          ...row,
                          weeklyPayments: {
                            week1: 0,
                            week2: 0,
                            week3: 0,
                            week4: 0,
                            week5: 0,
                            week6: 0,
                            week7: 0,
                            week8: 0,
                            week9: 0,
                            week10: 0,
                            ...row.weeklyPayments
                          }
                        });

                      }}
                      className="text-xl font-bold text-slate-800"
                    >
                      {row.name}
                    </button>

                    <p className="text-sm text-slate-500 mt-1">
                      {row.mobile}
                    </p>

                    {/* STATUS */}
                    <div className="mt-2 flex gap-2 flex-wrap">

                      {completed && (
                        <span className="bg-green-100 text-green-700 text-xs px-3 py-1 rounded-full">
                          Completed
                        </span>
                      )}

                      {due && (
                        <span className="bg-red-100 text-red-700 text-xs px-3 py-1 rounded-full">
                          Due
                        </span>
                      )}

                    </div>

                  </div>

                  <div className="text-right">

                    <p className="text-sm text-slate-500">
                      Balance
                    </p>

                    <h2 className="text-xl font-bold text-red-500">
                      ₹{balance}
                    </h2>

                  </div>

                </div>

                <div className="grid grid-cols-3 gap-3 mt-5">

                  <div className="bg-slate-50 rounded-2xl p-3">
                    <p className="text-xs text-slate-500">
                      Loan
                    </p>

                    <h3 className="font-bold text-slate-800 mt-1">
                      ₹{row.amount}
                    </h3>
                  </div>

                  <div className="bg-slate-50 rounded-2xl p-3">
                    <p className="text-xs text-slate-500">
                      Paid
                    </p>

                    <h3 className="font-bold text-green-600 mt-1">
                      ₹{paid}
                    </h3>
                  </div>

                  <div className="bg-slate-50 rounded-2xl p-3">
                    <p className="text-xs text-slate-500">
                      Profit
                    </p>

                    <h3 className="font-bold text-blue-700 mt-1">
                      ₹{total - row.amount}
                    </h3>
                  </div>

                </div>

                {/* ADMIN BUTTONS */}
                {isAdmin && (

                  <div className="flex gap-3 mt-5">

                    <button
                      onClick={() =>
                        handleDelete(row._id)
                      }
                      className="flex-1 bg-red-500 text-white py-3 rounded-2xl"
                    >
                      Delete
                    </button>

                    <button
                      onClick={() => {

                        setSelectedRow({
                          ...row,
                          weeklyPayments: {
                            week1: 0,
                            week2: 0,
                            week3: 0,
                            week4: 0,
                            week5: 0,
                            week6: 0,
                            week7: 0,
                            week8: 0,
                            week9: 0,
                            week10: 0,
                            ...row.weeklyPayments
                          }
                        });

                      }}
                      className="flex-1 bg-blue-700 text-white py-3 rounded-2xl"
                    >
                      Edit Record
                    </button>

                  </div>

                )}

              </div>

            );
          })}

        </div>

      </div>

      {selectedRow && (

        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">

          <div className="bg-white w-full max-w-4xl rounded-3xl p-5 max-h-[95vh] overflow-auto">

            <div className="flex justify-between items-center mb-5">

              <h2 className="text-2xl font-bold">
                {selectedRow.name}
              </h2>

              <button
                onClick={() => setSelectedRow(null)}
                className="bg-red-500 text-white px-4 py-2 rounded-2xl"
              >
                Close
              </button>

            </div>

            {/* IMAGES */}
            <div className="grid md:grid-cols-2 gap-5 mb-6">

              <div className="bg-slate-50 rounded-3xl p-4 text-center">

                <h3 className="font-bold mb-4">
                  Profile Photo
                </h3>

                <img
                  src={selectedRow.profilePhoto}
                  alt=""
                  className="w-52 h-52 object-cover rounded-3xl mx-auto"
                />

              </div>

              <div className="bg-slate-50 rounded-3xl p-4 text-center">

                <h3 className="font-bold mb-4">
                  ID Card
                </h3>

                <img
                  src={selectedRow.idPhoto}
                  alt=""
                  className="w-52 h-52 object-cover rounded-3xl mx-auto"
                />

              </div>

            </div>

            {/* WEEKLY */}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">

              {Array.from({ length: 10 }, (_, i) => {

                const weekKey = `week${i + 1}`;

                return (
                  <div
                    key={i}
                    className="bg-slate-50 rounded-2xl p-3"
                  >

                    <p className="text-sm font-semibold mb-2">
                      Week {i + 1}
                    </p>

                    <input
                      type="number"
                      disabled={!isAdmin}
                      value={
                        selectedRow?.weeklyPayments?.[weekKey] || 0
                      }
                      onChange={(e) =>
                        handleWeekChange(
                          selectedRow._id,
                          weekKey,
                          e.target.value
                        )
                      }
                      className={`w-full border rounded-xl px-3 py-2 outline-none ${
                        isAdmin
                          ? "bg-white border-slate-200"
                          : "bg-slate-100 border-slate-100 cursor-not-allowed"
                      }`}
                    />

                  </div>
                );
              })}

            </div>

            {/* NOTES */}
            <div className="mt-6">

              <label className="font-bold block mb-2">
                Notes
              </label>

              <textarea
                disabled={!isAdmin}
                value={selectedRow.notes || ""}
                onChange={(e) =>
                  setSelectedRow({
                    ...selectedRow,
                    notes: e.target.value,
                  })
                }
                className={`w-full rounded-2xl p-4 ${
                  isAdmin
                    ? "bg-slate-50 border border-slate-200"
                    : "bg-slate-100 border border-slate-100 cursor-not-allowed"
                }`}
                rows={4}
              />

            </div>

            {/* SAVE ONLY FOR ADMIN */}
            {isAdmin && (
              <button
                onClick={handleModalSave}
                className="w-full bg-blue-700 hover:bg-blue-800 transition text-white py-4 rounded-2xl mt-6 font-semibold"
              >
                Save Details
              </button>
            )}

          </div>

        </div>

      )}
      
    </div>
  );
}